/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Contact,
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
} from './Contact';
import {
    Membership,
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
} from './Membership';
import {
    ProgramAttendee,
    ProgramAttendeeFromJSON,
    ProgramAttendeeFromJSONTyped,
    ProgramAttendeeToJSON,
} from './ProgramAttendee';
import {
    SessionCreditObjectType,
    SessionCreditObjectTypeFromJSON,
    SessionCreditObjectTypeFromJSONTyped,
    SessionCreditObjectTypeToJSON,
} from './SessionCreditObjectType';
import {
    SessionCreditReason,
    SessionCreditReasonFromJSON,
    SessionCreditReasonFromJSONTyped,
    SessionCreditReasonToJSON,
} from './SessionCreditReason';
import {
    SessionCreditStatus,
    SessionCreditStatusFromJSON,
    SessionCreditStatusFromJSONTyped,
    SessionCreditStatusToJSON,
} from './SessionCreditStatus';

/**
 * 
 * @export
 * @interface SessionCredit
 */
export interface SessionCredit {
    /**
     * 
     * @type {string}
     * @memberof SessionCredit
     */
    id: string;
    /**
     * 
     * @type {SessionCreditObjectType}
     * @memberof SessionCredit
     */
    object: SessionCreditObjectType;
    /**
     * 
     * @type {string}
     * @memberof SessionCredit
     */
    program_id: string;
    /**
     * 
     * @type {Contact}
     * @memberof SessionCredit
     */
    contact: Contact;
    /**
     * 
     * @type {string}
     * @memberof SessionCredit
     */
    registration_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionCredit
     */
    event_id?: string;
    /**
     * 
     * @type {Membership}
     * @memberof SessionCredit
     */
    membership?: Membership;
    /**
     * 
     * @type {ProgramAttendee}
     * @memberof SessionCredit
     */
    program_attendee?: ProgramAttendee;
    /**
     * 
     * @type {boolean}
     * @memberof SessionCredit
     */
    is_void: boolean;
    /**
     * 
     * @type {SessionCreditReason}
     * @memberof SessionCredit
     */
    reason: SessionCreditReason;
    /**
     * 
     * @type {string}
     * @memberof SessionCredit
     */
    memo?: string;
    /**
     * 
     * @type {SessionCreditStatus}
     * @memberof SessionCredit
     */
    status: SessionCreditStatus;
    /**
     * 
     * @type {Date}
     * @memberof SessionCredit
     */
    expires_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof SessionCredit
     */
    timezone?: string;
    /**
     * 
     * @type {Date}
     * @memberof SessionCredit
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SessionCredit
     */
    updated?: Date;
}

export function SessionCreditFromJSON(json: any): SessionCredit {
    return SessionCreditFromJSONTyped(json, false);
}

export function SessionCreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionCredit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': SessionCreditObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'contact': ContactFromJSON(json['contact']),
        'registration_id': !exists(json, 'registration_id') ? undefined : json['registration_id'],
        'event_id': !exists(json, 'event_id') ? undefined : json['event_id'],
        'membership': !exists(json, 'membership') ? undefined : MembershipFromJSON(json['membership']),
        'program_attendee': !exists(json, 'program_attendee') ? undefined : ProgramAttendeeFromJSON(json['program_attendee']),
        'is_void': json['is_void'],
        'reason': SessionCreditReasonFromJSON(json['reason']),
        'memo': !exists(json, 'memo') ? undefined : json['memo'],
        'status': SessionCreditStatusFromJSON(json['status']),
        'expires_at': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'created': (new Date(json['created'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
    };
}

export function SessionCreditToJSON(value?: SessionCredit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': SessionCreditObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'contact': ContactToJSON(value.contact),
        'registration_id': value.registration_id,
        'event_id': value.event_id,
        'membership': MembershipToJSON(value.membership),
        'program_attendee': ProgramAttendeeToJSON(value.program_attendee),
        'is_void': value.is_void,
        'reason': SessionCreditReasonToJSON(value.reason),
        'memo': value.memo,
        'status': SessionCreditStatusToJSON(value.status),
        'expires_at': value.expires_at === undefined ? undefined : (value.expires_at.toISOString()),
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
    };
}

